var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFibudCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6614_9261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7605 17.4389L12 17.5696L12.2395 17.4389L18.5 14.0225V16.8833L12 20.4304L5.5 16.8833V14.0225L11.7605 17.4389ZM22.5 9.29682V16.5H21.5V10.09V9.24765L20.7605 9.65107L12 14.4304L2.04416 9L12 3.56954L22.5 9.29682Z",
    fill: "#A9A5B6",
    stroke: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6614_9261)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#089B7A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFibudCertificate);
export default __webpack_public_path__ + "static/media/fibud-certificate.5b693c4ff776bc9e44f299031c8d3eb3.svg";
export { ForwardRef as ReactComponent };